import React, { useState, useEffect } from 'react';
import { 
  FaFileAlt, 
  FaEye, 
  FaTrash,
  FaFilter
} from 'react-icons/fa';

const documentTypeOptions = [
  { value: '', label: 'Tümü' },
  { value: 'privacy_policy', label: 'Gizlilik Politikası' },
  { value: 'terms_of_service', label: 'Kullanım Şartları' },
  { value: 'cookie_policy', label: 'Çerez Politikası' },
  { value: 'data_processing_agreement', label: 'Veri İşleme Sözleşmesi' },
  { value: 'disclaimer', label: 'Sorumluluk Reddi' },
  { value: 'refund_policy', label: 'İade Politikası' },
  { value: 'acceptable_use_policy', label: 'Kabul Edilebilir Kullanım Politikası' }
];

const statusOptions = [
  { value: '', label: 'Tümü' },
  { value: 'generated', label: 'Aktif' },
  { value: 'draft', label: 'Ödeme Gerekli' }
];

const AdminDocuments = () => {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filterType, setFilterType] = useState('');
  const [filterStatus, setFilterStatus] = useState('');
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteTargetId, setDeleteTargetId] = useState(null);

  const fetchDocuments = async () => {
    try {
      const token = localStorage.getItem('token');
      const headers = {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      };

      let url = `/api/dashboard/admin/documents?page=${currentPage}&limit=10`;
      if (filterType) url += `&documentType=${filterType}`;
      if (filterStatus) url += `&status=${filterStatus}`;
      
      const documentsRes = await fetch(url, { headers });
      if (documentsRes.ok) {
        const documentsData = await documentsRes.json();
        setDocuments(documentsData.documents);
        setTotalPages(documentsData.totalPages);
      }
    } catch (error) {
      console.error('Error fetching documents:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDocuments();
  }, [currentPage, filterType, filterStatus]);

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('tr-TR', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getDocumentTypeLabel = (type) => {
    const labels = {
      'privacy_policy': 'Gizlilik Politikası',
      'terms_of_service': 'Kullanım Şartları',
      'cookie_policy': 'Çerez Politikası',
      'data_processing_agreement': 'Veri İşleme Sözleşmesi',
      'disclaimer': 'Sorumluluk Reddi',
      'refund_policy': 'İade Politikası',
      'acceptable_use_policy': 'Kabul Edilebilir Kullanım Politikası',
      'privacy-policy': 'Gizlilik Politikası',
      'terms-of-service': 'Kullanım Şartları',
      'cookie-policy': 'Çerez Politikası',
      'data-processing-agreement': 'Veri İşleme Sözleşmesi',
      'refund-policy': 'İade Politikası',
      'acceptable-use-policy': 'Kabul Edilebilir Kullanım Politikası'
    };
    return labels[type] || type;
  };

  const handleViewDocument = (doc) => {
    const pubId = doc.metadata?.publicationId;
    if (pubId) {
      window.open(`/result/${pubId}`, '_blank');
    } else {
      alert('Bu dökümanın görüntülenebilir sonucu yok.');
    }
  };

  const handleDeleteDocument = (documentId, title) => {
    setDeleteTargetId(documentId);
    setShowDeleteModal(true);
  };

  const confirmDeleteDocument = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`/api/dashboard/admin/document/${deleteTargetId}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      if (response.ok) {
        setDocuments(prev => prev.filter(doc => doc._id !== deleteTargetId));
        setShowDeleteModal(false);
        setDeleteTargetId(null);
      } else {
        const errorData = await response.json();
        alert(`Silme hatası: ${errorData.message}`);
      }
    } catch (error) {
      alert('Döküman silinirken bir hata oluştu.');
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="flex flex-col items-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-blue-500"></div>
          <p className="mt-4 text-gray-400">Yükleniyor...</p>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="bg-gray-800 border border-gray-700 rounded-xl">
        {/* Filters */}
        <div className="p-6 border-b border-gray-700">
          <div className="flex flex-wrap gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2">Döküman Türü</label>
              <select
                value={filterType}
                onChange={(e) => {
                  setFilterType(e.target.value);
                  setCurrentPage(1);
                }}
                className="px-3 py-2 bg-gray-700 border border-gray-600 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                {documentTypeOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-300 mb-2">Durum</label>
              <select
                value={filterStatus}
                onChange={(e) => {
                  setFilterStatus(e.target.value);
                  setCurrentPage(1);
                }}
                className="px-3 py-2 bg-gray-700 border border-gray-600 rounded-lg text-white focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                {statusOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="flex items-end">
              <button
                onClick={() => {
                  setFilterType('');
                  setFilterStatus('');
                  setCurrentPage(1);
                }}
                className="px-4 py-2 bg-gray-600 text-gray-300 rounded-lg hover:bg-gray-500 transition-colors"
              >
                <FaFilter className="inline mr-2" />
                Filtreleri Temizle
              </button>
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="p-6">
          <div className="overflow-x-auto">
            <table className="min-w-full">
              <thead>
                <tr className="border-b border-gray-700">
                  <th className="px-6 py-4 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">Döküman</th>
                  <th className="px-6 py-4 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">Kullanıcı</th>
                  <th className="px-6 py-4 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">Tür</th>
                  <th className="px-6 py-4 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">Durum</th>
                  <th className="px-6 py-4 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">Oluşturulma</th>
                  <th className="px-6 py-4 text-left text-xs font-medium text-gray-400 uppercase tracking-wider">İşlemler</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-gray-700">
                {documents.map((doc) => (
                  <tr key={doc._id} className="hover:bg-gray-700/50 transition-colors">
                    <td className="px-6 py-5 whitespace-nowrap">
                      <div className="flex items-center">
                        <FaFileAlt className="h-5 w-5 text-indigo-400 mr-3" />
                        <div className="text-sm font-medium text-white">{doc.title}</div>
                      </div>
                    </td>
                    <td className="px-6 py-5 whitespace-nowrap">
                      <div className="text-sm text-white font-medium">
                        {doc.userId?.firstName} {doc.userId?.lastName}
                      </div>
                    </td>
                    <td className="px-6 py-5 whitespace-nowrap">
                      <div className="text-sm text-white font-medium">{getDocumentTypeLabel(doc.documentType)}</div>
                    </td>
                    <td className="px-6 py-5 whitespace-nowrap">
                      <span className={`inline-flex px-3 py-1 text-xs font-semibold rounded-full ${
                        doc.status === 'generated' ? 'text-green-400 bg-green-900/20 border border-green-500/30' :
                        doc.status === 'draft' ? 'text-yellow-400 bg-yellow-900/20 border border-yellow-500/30' :
                        'text-gray-400 bg-gray-900/20 border border-gray-500/30'
                      }`}>
                        {doc.status === 'generated' ? 'Aktif' : doc.status === 'draft' ? 'Taslak' : doc.status}
                      </span>
                    </td>
                    <td className="px-6 py-5 whitespace-nowrap text-sm text-gray-400">
                      {formatDate(doc.createdAt)}
                    </td>
                    <td className="px-6 py-5 whitespace-nowrap">
                      <div className="flex items-center space-x-3">
                        <button 
                          onClick={() => handleViewDocument(doc)}
                          className="p-2 text-blue-400 hover:text-blue-300 hover:bg-blue-900/20 rounded-lg transition-colors"
                          title="Görüntüle"
                        >
                          <FaEye className="h-4 w-4" />
                        </button>
                        <button 
                          onClick={() => handleDeleteDocument(doc._id, doc.title)}
                          className="p-2 text-red-400 hover:text-red-300 hover:bg-red-900/20 rounded-lg transition-colors"
                          title="Sil"
                        >
                          <FaTrash className="h-4 w-4" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="flex items-center justify-between mt-6">
          <div className="flex-1 flex justify-between sm:hidden">
            <button
              onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
              disabled={currentPage === 1}
              className="relative inline-flex items-center px-4 py-2 border border-gray-600 text-sm font-medium rounded-lg text-gray-300 bg-gray-700 hover:bg-gray-600 disabled:opacity-50"
            >
              Önceki
            </button>
            <button
              onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
              disabled={currentPage === totalPages}
              className="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-600 text-sm font-medium rounded-lg text-gray-300 bg-gray-700 hover:bg-gray-600 disabled:opacity-50"
            >
              Sonraki
            </button>
          </div>
          <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
            <div>
              <p className="text-sm text-gray-400">
                Sayfa <span className="font-medium text-white">{currentPage}</span> /{' '}
                <span className="font-medium text-white">{totalPages}</span>
              </p>
            </div>
            <div>
              <nav className="relative z-0 inline-flex rounded-lg shadow-sm -space-x-px">
                <button
                  onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
                  disabled={currentPage === 1}
                  className="relative inline-flex items-center px-2 py-2 rounded-l-lg border border-gray-600 bg-gray-700 text-sm font-medium text-gray-300 hover:bg-gray-600 disabled:opacity-50"
                >
                  Önceki
                </button>
                <button
                  onClick={() => setCurrentPage(Math.min(totalPages, currentPage + 1))}
                  disabled={currentPage === totalPages}
                  className="relative inline-flex items-center px-2 py-2 rounded-r-lg border border-gray-600 bg-gray-700 text-sm font-medium text-gray-300 hover:bg-gray-600 disabled:opacity-50"
                >
                  Sonraki
                </button>
              </nav>
            </div>
          </div>
        </div>
      )}

      {/* Delete Confirmation Modal */}
      {showDeleteModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-gray-800 border border-gray-700 p-8 rounded-xl max-w-md w-full mx-4">
            <h2 className="text-xl font-semibold text-white mb-4">Dökümanı Sil</h2>
            <p className="text-gray-300 mb-6">Bu dökümanı silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.</p>
            <div className="flex justify-end space-x-3">
              <button
                onClick={() => setShowDeleteModal(false)}
                className="px-4 py-2 bg-gray-600 text-gray-300 rounded-lg hover:bg-gray-500 transition-colors"
              >
                İptal
              </button>
              <button
                onClick={confirmDeleteDocument}
                className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors"
              >
                Sil
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminDocuments;
